import { SelectItems } from 'Types/selectItems'
import { FieldNames } from 'Constants/FieldNames'
import { PaletteNames } from 'LibNeo'

export enum Statuses {
	CREATE = 'create',
	EDIT = 'edit',
}

export enum ADVERTISEMENT_TAB {
	ORGANIZATION = 'organizations',
	CONTRACT = 'contracts',
	CREATIVES = 'creatives',
	INVOICES = 'invoices',
}

export const AdvertTabTranslate = {
	[ADVERTISEMENT_TAB.ORGANIZATION]: 'Организации',
	[ADVERTISEMENT_TAB.CONTRACT]: 'Договоры',
	[ADVERTISEMENT_TAB.CREATIVES]: 'Креативы',
	[ADVERTISEMENT_TAB.INVOICES]: 'Отчёты',
}

export const SORT_OPTIONS: SelectItems = [
	{
		id: FieldNames.CREATED_AT,
		name: 'По дате регистрации',
	},
]

export enum StatusSlug {
	APPROVED = 'approved',
	NEW = 'new',
	PENDING = 'pending',
	DECLINED = 'declined',
	ACCEPTED = 'accepted',
	MEDIA_LOADING = 'media_loading',
}

export const StatusTranslate = {
	[StatusSlug.NEW]: 'Новая',
	[StatusSlug.APPROVED]: 'Одобрено',
	[StatusSlug.PENDING]: 'В процессе',
	[StatusSlug.DECLINED]: 'Отклонена',
	[StatusSlug.ACCEPTED]: 'Принято',
	[StatusSlug.MEDIA_LOADING]: 'Загрузка медиаданных',
}

export const convertStatusToPalleteColor = (status: StatusSlug): PaletteNames => {
	switch (status) {
		case StatusSlug.NEW:
			return 'gray'
		case StatusSlug.APPROVED:
			return 'emerald'
		case StatusSlug.PENDING:
			return 'gold'
		case StatusSlug.DECLINED:
			return 'pink'
		default:
			return 'gold'
	}
}

export enum ActionTypes {
	CREATE = 'CREATE',
	DELETE = 'DELETE',
	CLEAR = 'CLEAR',
}

export const CONTRACT_PARAMS = 'contractor'
